import {format, subMonths} from 'date-fns'

const getDateRangeForMonths = (monthsAgo: number) => {
    const startDate = format(subMonths(new Date(), monthsAgo), 'yyyy-MM-dd')

    return {startDate, endDate: undefined}
}

export const getStartDateForPeriod = (period: 'last_month' | 'last_3_month' | 'last_6_month') => {
    if (period == 'last_month') {
        return getDateRangeForMonths(1)
    } else if (period == 'last_3_month') {
        return getDateRangeForMonths(3)
    } else {
        return getDateRangeForMonths(6)
    }
}

export const QUALITY_STATUS_COLORS = {
    onTrack: 'var(--color-success-600)',
    gettingThere: 'var(--color-warning-300)',
    roomToImprove: 'var(--color-warning-500)'
} as const

export const getBarColor = (quality: number) => {
    if (quality >= 90) return QUALITY_STATUS_COLORS.onTrack
    if (quality >= 70) return QUALITY_STATUS_COLORS.gettingThere
    return QUALITY_STATUS_COLORS.roomToImprove
}
